import { NgModule } from '@angular/core';
import { CartComponent } from '~shared/svgs/cart/cart.component';


@NgModule({
  declarations: [
    CartComponent
  ],
  exports: [
    CartComponent
  ]
})
export class CartModule {}
